export class LoadApptsModel {
    appointment_id: number
    dropoff_time: string
    dropoff_time_needed: number
    doctor: string
    doctor_time_needed: number
    appointment_note: string
    dropoff: number

    private _time: string;

    set time(value: string) {
        this._time = value;
    }
    get time(): string {
        let p1 = this.dropoff_time.split(' ');
        if (p1 && p1.length > 1) {
            let p2 = p1[1].split(':');
            if (p2 && p2.length) {
                let time = new Date(0, 0, 0, Number(p2[0]), Number(p2[1]), Number(p2[2]));
                return time.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
            }
        }
        return ``;
    }

    constructor(
        appointment_id: number,
        dropoff_time: string,
        dropoff_time_needed: number,
        doctor: string,
        doctor_time_needed: number,
        appointment_note: string,
        dropoff: number
    ) {
        this.appointment_id = appointment_id
        this.dropoff_time = dropoff_time
        this.dropoff_time_needed = dropoff_time_needed
        this.doctor = doctor
        this.doctor_time_needed = doctor_time_needed
        this.appointment_note = appointment_note
        this.dropoff = dropoff
    }
}